import { Injectable, Inject } from '@angular/core';
import { Http, Headers, Response, Request, RequestOptions, URLSearchParams, RequestMethod } from '@angular/http';
import { Observable, ReplaySubject, Subject } from 'rxjs';
import { TranslateService } from './translate.service';
import { ApiRequestService } from './api-request.service';

@Injectable()
export class AgentService {

    public agent;
    public currentAgent = "Loading";
    public privilegeList = [];
    public version = null;

    public SetAgent(resp) {
        this.agent = resp;
        this.currentAgent = this.agent.firstName;
        this.fetchByAgentUserId(this.agent.emailId).subscribe(resp => {
            this.agent = JSON.parse(JSON.stringify(resp));
            if (this.agent[0].clientDO.clientTypeCd == 'ORGANIZATION') {
                this.currentAgent = this.agent[0].clientDO.organisationDO.companyName
            }
            else {
                this.currentAgent = this.agent[0].clientDO.personDO.firstName
            }
        })
        localStorage.setItem("loggedInUser", this.agent);
        console.log("this.agent.firstName");
        //console.log(this.agent.firstName);

    }

    constructor(
        private apiRequest: ApiRequestService,
        private translate: TranslateService
    ) { }

    //Fetch a single policy based on id

    getAgentById(id: number): Observable<any> {
        let me = this;
        let agentArr = [];// to simulate dedup
        let agentDataSubject: ReplaySubject<any> = new ReplaySubject<any>(1); // Will use this subject to emit data that we want

        this.apiRequest.get('agent/fetchById/' + id)
            .subscribe(jsonResp => {
                let returnObj = jsonResp;
                agentArr.push(jsonResp);
                console.log(agentArr);
                agentDataSubject.next(agentArr); // incidentList is a Subject and emits an event thats being listened to by the components
            });

        return agentDataSubject;
    }

    getAgentByAgentNum(agentNum: number): Observable<any> {
        let me = this;
        let agentArr = [];// to simulate dedup
        let agentDataSubject: ReplaySubject<any> = new ReplaySubject<any>(1); // Will use this subject to emit data that we want

         let searchURL = "agentFetchByAgentNum/" + agentNum;
        this.apiRequest.getCallWithAPIMapper(searchURL)
            .subscribe(jsonResp => {
                let returnObj = jsonResp;
                agentArr.push(jsonResp);
                console.log(agentArr);
                agentDataSubject.next(agentArr); // incidentList is a Subject and emits an event thats being listened to by the components
            });

        return agentDataSubject;
    }


    fetchByAgentUserId(userId: string): Observable<any> {
        let me = this;
        let agentArr = [];// to simulate dedup
        let agentDataSubject: ReplaySubject<any> = new ReplaySubject<any>(1); // Will use this subject to emit data that we want

        this.apiRequest.get('agent/fetchByAgentUserId/' + userId)
            .subscribe(jsonResp => {
                let returnObj = jsonResp;
                agentArr.push(jsonResp);
                console.log(agentArr);
                agentDataSubject.next(agentArr); // incidentList is a Subject and emits an event thats being listened to by the components
            });

        return agentDataSubject;
    }

    saveAgent(agentIO): Observable<any> {
        let self = this; //let policyIO = policyIO
        let agentDataSubject = new Subject<any>(); // Will use this subject to emit data that we want after ajax save policy attempt
        this.apiRequest.post('agent/save', agentIO)
            .subscribe(jsonResp => {
                agentDataSubject.next(jsonResp);

            }, errResp => {
                agentDataSubject.next(errResp);
            })
        return agentDataSubject;
    }

    searchAgent(searchParams): Observable<any> {
        let me = this;
        let params = [];
        params.push(searchParams.agentNum);
        params.push(searchParams.channelCd);
        params.push(searchParams.subChannelCd);
        params.push(searchParams.partnerCd);
        params.push(searchParams.partnrbranchCd);
        params.push(searchParams.firstName);
        params.push(searchParams.lastName);

        let clientDataSubject: ReplaySubject<any> = new ReplaySubject<any>(1); // Will use this subject to emit data that we want

        this.apiRequest.get('agent/searchAgents/' + params)
            .subscribe(jsonResp => {

                let returnObj = jsonResp;
                console.log(returnObj);
                clientDataSubject.next(returnObj); // incidentList is a Subject and emits an event thats being listened to by the components
            });

        return clientDataSubject;
    }

    fetchAgentPrivileges(): Observable<any> {

        let agentPrivilegesSubject: ReplaySubject<any> = new ReplaySubject<any>(1);
        this.apiRequest.getCallWithAPIMapper('menuV2')
            .subscribe(jsonResp => {
                this.privilegeList = jsonResp;
                agentPrivilegesSubject.next(this.privilegeList);
            });

        return agentPrivilegesSubject;
    }

    getVersion(application): Observable<any> {

        let versionSubject: ReplaySubject<any> = new ReplaySubject<any>(1);
        this.apiRequest.get('getAppVersion/' + application)
            .subscribe(jsonResp => {
                this.version = jsonResp;
                versionSubject.next(this.version);
            });

        return versionSubject;
    }

    getPrivilegeList() {
        return this.privilegeList;
    }

    isParticularPrivilegePresent(privilegeCd) {
        let isPrivilege = false;
        if (this.privilegeList.length > 0) {
            for (var i = 0; i < this.privilegeList.length; i++) {
                if (this.privilegeList[i].privilegeCd == privilegeCd) {
                    isPrivilege = true;
                }
            }
        } else {
            isPrivilege = true;
        }
        return isPrivilege;
    }
}
